import { render, staticRenderFns } from "./FooterLink.vue?vue&type=template&id=f1850e46"
import script from "./FooterLink.vue?vue&type=script&lang=ts"
export * from "./FooterLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports